export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // eslint-disable-next-line no-undef

/*
  var breakpoint_xs;
  var breakpoint_sm;
  var breakpoint_md;
  var breakpoint_lg;
  var breakpoint_xl;

  breakpoint_xs = 0;
  breakpoint_sm = 576;
  breakpoint_md = 768;
  breakpoint_lg = 992;
  breakpoint_xl = 1200;
*/

    // JavaScript to be fired on all pages, after page specific JS is fired
    $('.grid').masonry({
      // options...
      itemSelector: '.grid-item',
      percentPosition: true,
    });

    load_posts();

    function load_posts(){
      var wpnonce = $('#posts-wrapper').attr('data-nonce');
      var posts_per_page = $('#posts-wrapper').attr('data-posts-per-page');
      var cur_page = $('#posts-wrapper').attr('data-current-page');
      $('.loadmore-nav').find('.loader').removeClass('d-none');

      $.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        dataType: 'json',
        data: {
          action: 'load_more_posts',
          _wpnonce: wpnonce,
          _cur_page: cur_page,
          _posts_per_page: posts_per_page,
        },
        success: function (output) {

          if(output.lastpage === false) {
            $('.loadmore-nav').find('.loader').addClass('d-none');
          } else {
            $('.loadmore-nav').remove();
          }

          var newPosts = output.posts;
          var newPostID = parseInt(cur_page) + 1;
          var posts = $.parseJSON(output.posts);
          var thePosts = '';

          $.each(posts, function(index, post){
            if(post !== undefined) {
              thePosts += post;
              //console.log(post);
            }
          });

          if(thePosts !== undefined) {
            $('#posts-wrapper').append('<span id="posts-page-'+ ( parseInt(cur_page) + 1) +'"></span>');
            $('#posts-wrapper').append(thePosts);
          }

          $('.grid').masonry('destroy');
          $('.masonry-container').removeData('masonry'); // This line to remove masonry's data
          $('.grid').masonry({
            // options...
            itemSelector: '.grid-item',
            percentPosition: true,
          });
          console.log(newPostID, $('#posts-page-'+newPostID).offset().top)
          //$('html,body').animate({
            //scrollTop: ($('#posts-page-'+newPostID).offset().top -20),
          //}, 500);

          $('#posts-wrapper').attr('data-current-page',newPostID);

        },
      });
    }

    $('.loadmore-nav').click( function(){

              load_posts();

    });

    var balanceText = require('balance-text');
    balanceText($('.balance-text'), {watch: true});
    balanceText($('#menu-main-menu a'), {watch: true});

    $('#desktop-navigation ul.nav li.menu-item-has-children').each( function(){
      $(this).children('a').attr('data-toggle', 'collapse');
      $(this).children('a').on('click', function(){
        window.location = $(this).attr('href');
      });
      $(this).children('ul.sub-menu').addClass('collapse ');



    });


    checkForNavHover();

    function checkForNavHover() {
       setTimeout(checkForNavHover,1000);
       $('#desktop-navigation ul.nav li.menu-item-has-children').each( function(){
         if($(this).is(':hover')) {
           console.log('null');
         } else {
           $(this).children('ul.sub-menu').removeClass('show ');
         }
      });
    }


    $('#desktop-navigation ul.nav li.menu-item-has-children').hoverIntent(function(){
      $(this).children('ul.sub-menu').collapse('toggle');
    },
    function(){
      $(this).children('ul.sub-menu').collapse('toggle');
    });

    var navWaypoint = $('#site-header').waypoint(function(direction) {

        if(direction == 'down') {
          $('#desktop-navigation.nav-primary').addClass('fixed-top fadeInDown');
          $('#site-header').addClass('fixed-nav');
        }
        if(direction == 'up') {
          $('#desktop-navigation.nav-primary').removeClass('fixed-top fadeInDown');
          $('#site-header').removeClass('fixed-nav');
        }


    }, {
      offset: $('#site-header').outerHeight(true) * -1,
    });
    navWaypoint;


    $('.nav-icon').click(function(){
      $(this).toggleClass('active');
      $('html').toggleClass('nav-open');
    });

    $(window).resize( function(){
      if($(this).width() > 992 ) {
        $('html').removeClass('nav-open');
      }
    });

    $('a').each(function(){

      if($(this).attr('target') === '_blank' && $(this).find('img').length <= 0) {
        console.log($(this).find('img'));
        $(this).append('<i class="fas fa-external-link-alt ml-1"></i>');
      }
    });

    $('.wp-block-cover').each(function(){
      if($(this).find('h2 a').length) {
        var linktext = $(this).find('h2 a').text();
        var link = $(this).find('h2 a').attr('href');
        $(this).find('h2').text(linktext);

        $(this).attr('href', link);
        $(this).changeElementType('a');

      }
    });

    $('.keynotes figure').on('click', function() {
      var me = $(this).attr('rel');
      $('.keynotes figure.active').each(function() {
        console.log($(this).attr('rel'), me, $(this).attr('rel') == me);
        if ($(this).attr('rel') != me) {
          $(this).removeClass('active').next('.biography').removeClass('active').slideUp(100);
        }
      });
      $(this).toggleClass('active').next('.biography').toggleClass('active').slideToggle(500);
    });
    $('dl.accordion dt').on('click', function() {
      $(this).toggleClass('active').next('dd').toggleClass('active').slideToggle(500);
    });
    $('.wp-block-group.expander > .wp-block-group__inner-container > h2').on('click', function() {
      $(this).toggleClass('active').next('.wp-block-columns').find('.wp-block-column').toggleClass('active').slideToggle(500);
    });

    $('.agenda-table .item.has-details .title').on('click', function() {
      $(this).toggleClass('active').next('.details').toggleClass('active').slideToggle(500);
    });

    $('.agenda-table .event-title.has-details').on('click', function() {
      $(this).toggleClass('active').next('.event-details').toggleClass('active').slideToggle(500);
    });

    $('#search-field-wrapper .search-form').append('<a href="#search-field-wrapper" class="search-field-close-btn" data-toggle="collapse">x</a>');


    $(document).ready(function() {
      $('.news-feed-columns .left-column, .news-feed-columns .right-column').theiaStickySidebar({
        // Settings
        additionalMarginTop: 80,
      });
    });

  },
};

$.fn.changeElementType = function(newType) {
      var attrs = {};

      $.each(this[0].attributes, function(idx, attr) {
          attrs[attr.nodeName] = attr.nodeValue;
      });

      this.replaceWith(function() {
          return $('<' + newType + '/>', attrs).append($(this).contents());
      });
  };



// WEBPACK FOOTER //
// ./scripts/routes/common.js